import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { Chat, ChatSkeleton, ExploreSkeleton } from "../features/Chat";
import { useIntercomIntegration } from "@shared/services/intercom/useIntercomIntegration";
import { WelcomeWrapper } from "@features/Welcome/WelcomeWrapper";
import { OnboardingGuidedTour } from "@features/GuidedTours/OnboardingGuidedTour";
import { withMainLayout } from "@shared/layouts/withMainLayout";

type ChatPageView = "chat" | "explore" | "focus";

function ChatPageContent({ view = "chat" }: { view?: ChatPageView }) {
  const { threadId: currentThread } = useParams<{ threadId: string }>();
  const navigate = useNavigate();
  useIntercomIntegration();

  const navigateToThread = useCallback(
    (threadId: string | null) => {
      navigate(threadId ? `/chat/${threadId}` : "/");
    },
    [navigate],
  );

  return (
    <>
      <Chat
        currentThread={currentThread}
        navigateToThread={navigateToThread}
        view={view}
      />
      <OnboardingGuidedTour />
      <WelcomeWrapper />
    </>
  );
}

export const ChatPage = withMainLayout(ChatPageContent);

function ChatPageSkeletonContent() {
  return <ChatSkeleton />;
}

function ChatPageExploreSkeletonContent() {
  return <ExploreSkeleton />;
}

export const ChatPageSkeleton = withMainLayout(ChatPageSkeletonContent);
export const ChatPageExploreSkeleton = withMainLayout(
  ChatPageExploreSkeletonContent,
);
